/**
 * @file Custom print related queries.
 */
import gql from 'graphql-tag';

import {
  PurchasedCustomPrintFullDetails,
  PurchasedCustomPrintProCandidatePhotosDetails,
} from '../fragments/custom-prints';
import { PhotoUrlTypeFields } from '../fragments/album';

export const PurchasedCustomPrintForConfig = gql`
  query purchasedCustomPrintForConfig($id: RecordID!) {
    purchasedCustomPrint(id: $id) {
      ...PurchasedCustomPrintFullDetails
    }
  }
  ${PurchasedCustomPrintFullDetails}
`;

export const PurchasedCustomPrintProCandidatePhotos = gql`
  query purchasedCustomPrintProCandidatePhotos(
    $id: RecordID!
    $limit: Int = 20
    $matchesOffset: Int = 0
    $favoritesOffset: Int = 0
    $albumPhotosOffset: Int = 0
  ) {
    purchasedCustomPrint(id: $id) {
      ...PurchasedCustomPrintProCandidatePhotosDetails
    }
  }
  ${PurchasedCustomPrintProCandidatePhotosDetails}
`;

export const PurchasedCustomPrintsAwaitingProConfig = gql`
  query purchasedCustomPrintsAwaitingProConfig($albumId: RecordID!) {
    album(id: $albumId) {
      id
      purchased_custom_prints(
        slice: { limit: 999 }
        custom_print_types: [CUSTOM_PRINT, COLLAGE]
        order_statuses: [CUSTOMER_INPUT]
        vendor_configuration: true
      ) {
        total
        records {
          id
          name
        }
      }
    }
  }
`;

export const CustomPrintConfigurationPhotos = gql`
  query customPrintConfigurationPhotos(
    $purchasedCustomPrintId: RecordID
    $albumCustomPrintId: RecordID
    $accountId: RecordID
    $identityId: RecordID
    $limit: Int = 20
    $matchesOffset: Int = 0
    $favoritesOffset: Int = 0
    $allPhotosOffset: Int = 0
  ) {
    customPrintConfigurationPhotos(
      purchased_custom_print_id: $purchasedCustomPrintId
      album_custom_print_id: $albumCustomPrintId
      account_id: $accountId
      identity_id: $identityId
    ) {
      matched_photos_extended(
        slice: { limit: $limit, offset: $matchesOffset }
      ) {
        total
        records {
          id
          photo {
            id
            thumbnail_urls(ignore_watermark: true) {
              ...PhotoUrlTypeFields
            }
          }
        }
      }
      favorited_photos(slice: { limit: $limit, offset: $favoritesOffset }) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
        }
      }
      all_photos(slice: { limit: $limit, offset: $allPhotosOffset }) {
        total
        records {
          id
          thumbnail_urls(ignore_watermark: true) {
            ...PhotoUrlTypeFields
          }
        }
      }
    }
  }
  ${PhotoUrlTypeFields}
`;

export const CustomPrintTiers = gql`
  query customPrintTiers($custom_print_types: [CustomPrintTypeEnum]) {
    customPrintTiers(custom_print_types: $custom_print_types) {
      id
      custom_print_type
      amount_from
      amount_to
      price {
        value
        currency
      }
      is_active
    }
  }
`;
